export const ActualizarData = (dataPrevia, idKey, nuevasOc = []) => {
    const dataFolio = dataPrevia.map((oc) => oc[idKey]);
    nuevasOc.forEach((rowActualizado) => {
        const indice = dataFolio.indexOf(rowActualizado[idKey]);
        if (indice >= 0) dataPrevia.splice(indice, 1, rowActualizado);
        else dataPrevia.splice(0, 0, rowActualizado);
    });
    return dataPrevia;
};
